import React, {FC} from 'react';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import {useUpdateWorkerStatus} from "../redux/workers.hook";

const useStyles = makeStyles((theme) => ({
    activateButtonContained: {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.error.contrastText
    },
    deactivateButtonContained: {
        backgroundColor: theme.palette.error.light,
        color: theme.palette.error.contrastText
    },
    activateButton: {
        color: theme.palette.success.main
    },
    deactivateButton: {
        color: theme.palette.error.main
    }
}))

interface WorkerStatusDialogProps {
    workerId: string;
    workerName: string;
    active: boolean;
    className?: string;
}

export const WorkerStatusDialog: FC<WorkerStatusDialogProps> = ({workerId, workerName, active, className}) => {
    const classes = useStyles();
    const {updateWorkerStatus} = useUpdateWorkerStatus();

    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const handleUpdateWorkerStatus = () => {
        setLoading(true);
        updateWorkerStatus(workerId, !active)
            .catch(() => {
            })
            .finally(() => {
                setLoading(false);
                setDialogOpen(false);
            });
    };
    return (
        <>
            <Button
                size="small"
                onClick={() => setDialogOpen(true)}
                className={clsx(active ? classes.deactivateButtonContained : classes.activateButtonContained, className)}
                variant={"contained"}
            >
                {active ? 'Deaktivieren' : 'Aktivieren'}
            </Button>
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle>{active ? 'Arbeiter deaktivieren' : 'Arbeiter aktivieren'}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {active
                            ? `Achtung! Sobald der Mitarbeiter "${workerName}" deaktiviert wurde kann sich dieser nicht mehr in die Mitarbeiter-App einloggen und wird nicht mehr für Buchungsanfragen berücksichtigt. Ein späteres Aktivieren ist möglich.`
                            : `Sobald der Mitarbeiter "${workerName}" aktiviert wurde, kann er sich wieder in der Mitarbeiter-App einloggen.`
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {loading
                        ? <CircularProgress color="primary"/>
                        : (
                            <React.Fragment>
                                <Button onClick={() => setDialogOpen(false)}>
                                    Abbrechen
                                </Button>
                                <Button
                                    className={active ? classes.deactivateButton : classes.activateButton}
                                    onClick={handleUpdateWorkerStatus}
                                >
                                    {active ? 'Deaktivieren' : 'Aktivieren'}
                                </Button>
                            </React.Fragment>
                        )}
                </DialogActions>
            </Dialog>
        </>
    )
}